import script from "./ThreeDAssemblyOrderablePartsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThreeDAssemblyOrderablePartsCard.vue?vue&type=script&setup=true&lang=ts"

import "./ThreeDAssemblyOrderablePartsCard.vue?vue&type=style&index=0&id=d98463c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d98463c4"]])

export default __exports__